<template>
  <div class="download">
    <banner :img="downloadBanner" title="下载 APP" subtitle="MOBILE EXPERIENCE" />
    <section class="download-content">
      <div class="download-content__copy" v-reveal>
        <span class="download-content__index">01</span>
        <h2>让工程信息随时触达</h2>
        <p>移动端帮助团队查看项目动态、留存现场记录并快速同步关键事项，让管理过程更清晰、更高效。</p>
        <ul>
          <li><i class="el-icon-circle-check"></i> 项目信息集中查看</li>
          <li><i class="el-icon-circle-check"></i> 现场记录便捷留痕</li>
          <li><i class="el-icon-circle-check"></i> 多角色协同与进度跟踪</li>
        </ul>
        <div class="download-content__tip">
          <i class="el-icon-mobile-phone"></i>
          <div>
            <strong>获取移动端</strong>
            <span>扫描右侧二维码，或联系尚亚科技获取安装与使用支持。</span>
          </div>
        </div>
      </div>
      <div class="download-content__visual" v-reveal="120">
        <div class="phone-card">
          <div class="phone-card__speaker"></div>
          <div class="phone-card__screen">
            <img :src="qrCode" alt="尚亚科技移动端二维码" />
            <strong>尚亚科技</strong>
            <span>工程管理移动服务</span>
          </div>
        </div>
        <div class="visual-orbit visual-orbit--one"></div>
        <div class="visual-orbit visual-orbit--two"></div>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import downloadBanner from "../assets/img/appDown.jpg";
import qrCode from "../assets/img/ercode.png";

export default {
  components: {
    Banner
  },
  data() {
    return {
      downloadBanner,
      qrCode
    };
  }
};
</script>

<style lang="scss" scoped>
.download {
  background: var(--surface-soft);
}

.download-content {
  display: grid;
  width: min(calc(100% - 40px), 1120px);
  margin: 0 auto;
  padding: var(--section-space) 0;
  grid-template-columns: 1.05fr 0.95fr;
  align-items: center;
  gap: clamp(50px, 9vw, 120px);
}

.download-content__copy {
  position: relative;
}

.download-content__index {
  display: inline-grid;
  width: 48px;
  height: 48px;
  margin-bottom: 28px;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 50%;
  color: var(--brand-600);
  background: #fff;
  font-family: Georgia, serif;
  font-size: 13px;
  box-shadow: var(--shadow-sm);
}

.download-content h2 {
  color: var(--ink-950);
  font-size: var(--text-h2);
  font-weight: 700;
  line-height: 1.24;
}

.download-content__copy > p {
  max-width: 620px;
  margin-top: 22px;
  color: var(--ink-600);
  font-size: 16px;
  line-height: 2;
}

.download-content ul {
  display: grid;
  margin-top: 30px;
  list-style: none;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
}

.download-content li {
  display: flex;
  align-items: center;
  gap: 9px;
  color: var(--ink-800);
  font-size: 14px;
}

.download-content li i {
  color: var(--success);
  font-size: 17px;
}

.download-content__tip {
  display: flex;
  margin-top: 38px;
  padding: 20px 22px;
  align-items: center;
  gap: 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: #fff;
  box-shadow: var(--shadow-sm);
}

.download-content__tip > i {
  color: var(--brand-600);
  font-size: 34px;
}

.download-content__tip div {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.download-content__tip strong {
  color: var(--ink-950);
  font-size: 15px;
}

.download-content__tip span {
  color: var(--ink-600);
  font-size: 13px;
  line-height: 1.6;
}

.download-content__visual {
  position: relative;
  display: grid;
  min-height: 520px;
  place-items: center;
  overflow: hidden;
  border-radius: var(--radius-xl);
  background:
    radial-gradient(circle at 70% 20%, rgba(240, 207, 140, 0.28), transparent 28%),
    linear-gradient(145deg, var(--brand-950), var(--brand-700));
  box-shadow: var(--shadow-lg);
}

.phone-card {
  position: relative;
  z-index: 2;
  width: 230px;
  height: 430px;
  padding: 18px 12px 14px;
  border: 7px solid var(--brand-950);
  border-radius: 38px;
  background: var(--brand-950);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.34);
  transform: rotate(5deg);
}

.phone-card__speaker {
  position: absolute;
  top: 8px;
  left: 50%;
  z-index: 3;
  width: 64px;
  height: 5px;
  border-radius: 8px;
  background: var(--brand-800);
  transform: translateX(-50%);
}

.phone-card__screen {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 44px 22px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 26px;
  color: var(--ink-950);
  background:
    linear-gradient(180deg, rgba(223, 243, 251, 0.76), #fff 42%);
}

.phone-card__screen img {
  width: 146px;
  height: 146px;
  padding: 8px;
  border-radius: 18px;
  background: #fff;
  box-shadow: var(--shadow-sm);
}

.phone-card__screen strong {
  margin-top: 28px;
  font-size: 21px;
}

.phone-card__screen span {
  margin-top: 8px;
  color: var(--ink-600);
  font-size: 12px;
  letter-spacing: 0.1em;
}

.visual-orbit {
  position: absolute;
  border: 1px solid var(--glass-border);
  border-radius: 50%;
}

.visual-orbit--one {
  width: 420px;
  height: 420px;
}

.visual-orbit--two {
  width: 570px;
  height: 570px;
}

@media (max-width: 860px) {
  .download-content {
    grid-template-columns: 1fr;
  }

  .download-content__visual {
    min-height: 480px;
  }
}

@media (max-width: 768px) {
  .download {
    min-height: calc(100vh - var(--mobile-header-height));
  }

  .download-content {
    width: 100%;
    padding: 56px var(--mobile-gutter);
    gap: 40px;
  }

  .download-content ul {
    grid-template-columns: 1fr;
  }

  .download-content__visual {
    min-height: 420px;
  }

  .phone-card {
    width: 200px;
    height: 374px;
  }

  .phone-card__screen img {
    width: 124px;
    height: 124px;
  }
}
</style>
